import { TIME_LINE_INTERVAL_MINUTES, TIME_LINE_INTERVAL_WIDTH } from '@/src/lib/constants'

export const pxToIntervalMinutes = (px: number): number =>
  Math.round(px / TIME_LINE_INTERVAL_WIDTH) * TIME_LINE_INTERVAL_MINUTES
